<template>
  <ion-toolbar>
    <ion-buttons slot="start" v-if="routeName == 'locum_jobseeker_preview'">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Preview Profile</h1>
          <p class="auth-subtext">Please check profile details!</p>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
        </div>
      </div>
      <div class="profile-preview-wrapper">
        <div class="preview-section">
          <div class="profile-picture">
            <el-avatar :size="'large'" :src="userData?.image" v-if="userData?.image" />
            <el-avatar :size="'large'" icon="el-icon-user-solid" v-else></el-avatar>
            <el-button type="transparent" @click="links.changePhoto" data-testid="avatar-btn">
              <span class="locumate_icons locumate_icon-camera"></span>
            </el-button>
          </div>
          <div class="profile-info">
            <div class="profile-name">
              {{ userData.name }}
            </div>
            <div class="profile-type">
              <!-- {{ $filters.userRoleConversion(userData) }} -->
                {{ userData.platformRole }}
            </div>
          </div>
        </div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              About Me
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openDialog">
              <EditOutlineIcon />
            </div>
          </div>
          <p class="preview-section__content" v-if="displayedText">
            {{ displayedText }}
            <el-button class="text-only" @click="toggleView"  v-if="isDisplayButtonVisible"> {{ state.isTruncated ? 'View More' : 'View Less' }}</el-button>
          </p>
        </div>
        <div class="separator"></div>
        <div class="preview-section">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Basic Details
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-item__icon">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.5 6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375H5.25"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.5 12.375H6" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.5 9.375H3.75" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                  stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="detail-item__value">{{ userData.email }}</div>
          </div>
          <div class="detail-item">
            <div class="detail-item__icon">
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 5.25V12.75C13 15.75 12.25 16.5 9.25 16.5H4.75C1.75 16.5 1 15.75 1 12.75V5.25C1 2.25 1.75 1.5 4.75 1.5H9.25C12.25 1.5 13 2.25 13 5.25Z"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M8.5 4.125H5.5" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M6.9999 14.325C7.64193 14.325 8.1624 13.8045 8.1624 13.1625C8.1624 12.5205 7.64193 12 6.9999 12C6.35787 12 5.8374 12.5205 5.8374 13.1625C5.8374 13.8045 6.35787 14.325 6.9999 14.325Z"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="detail-item__value">{{ userData.mobileNumber }}</div>
          </div>
          <div class="detail-item" v-if="userData.hrFlowData?.educations?.length && userData.hrFlowData?.educations[0]?.title">
            <div class="detail-item__icon">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.53739 1.89747L3.02239 4.84497C1.57489 5.78997 1.57489 7.90497 3.02239 8.84997L7.53739 11.7975C8.34739 12.33 9.68239 12.33 10.4924 11.7975L14.9849 8.84997C16.4249 7.90497 16.4249 5.79747 14.9849 4.85247L10.4924 1.90497C9.68239 1.36497 8.34739 1.36497 7.53739 1.89747Z"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M4.22259 9.81006L4.21509 13.3276C4.21509 14.2801 4.95009 15.3001 5.85009 15.6001L8.24259 16.3951C8.65509 16.5301 9.33759 16.5301 9.75759 16.3951L12.1501 15.6001C13.0501 15.3001 13.7851 14.2801 13.7851 13.3276V9.84756"
                  stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M16.05 11.25V6.75" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="detail-item__value">{{ userData.hrFlowData?.educations[0]?.title }}</div>
          </div>
          <div class="role-class-top" v-if="userData.seekerRole?.length">
            <div class="preview-section__title">
              Looking for role(s)
            </div>
            <div class="mt-10-role">
              <div class="skill-list-pills">
            <el-tag v-for="(skill, index) in userData.seekerRole" :key="index" class="inverted pill">{{ skill === "Other" ? `${skill}: ${userData.settings.categoryLevelOther}` : skill }}</el-tag>

          </div>
            </div>
            
          </div>
        </div>
        <!-- <div class="separator" v-if="userData.seekerRole?.length > 0"></div>
        <div class="preview-section" v-if="userData.seekerRole?.length > 0">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Looking for role(s)
            </div>
    
          </div>

          <div class="skill-list-pills">
            <el-tag v-for="(skill, index) in userData.seekerRole" :key="index" class="inverted pill">{{ skill
              }}</el-tag>

          </div>
        </div> -->
        <div class="separator" v-if="userData.settings?.hrFlowData?.experiences"></div>
        <div class="preview-section" v-if="userData.settings?.hrFlowData?.experiences">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Experience
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openExperienceDialog">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path
                    d="M8.84006 2.39982L3.36673 8.19315C3.16006 8.41315 2.96006 8.84649 2.92006 9.14649L2.6734 11.3065C2.58673 12.0865 3.14673 12.6198 3.92006 12.4865L6.06673 12.1198C6.36673 12.0665 6.78673 11.8465 6.9934 11.6198L12.4667 5.82649C13.4134 4.82649 13.8401 3.68649 12.3667 2.29315C10.9001 0.913152 9.78673 1.39982 8.84006 2.39982Z"
                    stroke="#484848" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003" stroke="#484848"
                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2 14.6665H14" stroke="#484848" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>

            </div>
          </div>
          <div class="enhance-item border-box" v-for="(exp,index) in userData.settings?.hrFlowData?.experiences"
            :key="index">

            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2459_4910)">
                  <path
                    d="M16.2354 0H7.76481V8.47059H16.2354V0ZM14.1177 4.94118H12.706V6.35294H11.2942V4.94118H9.88245V3.52941H11.2942V2.11765H12.706V3.52941H14.1177V4.94118ZM17.6472 5.64706H22.5883V8.47059H17.6472V5.64706ZM1.41187 5.64706H6.35304V8.47059H1.41187V5.64706ZM14.8236 12.9247V14.1176H19.0589V12.9247C17.6621 12.6344 16.2205 12.6344 14.8236 12.9247Z"
                    fill="rgb(var(--locumate-primary-color))" />
                  <path
                    d="M1.41176 9.88232V22.5882H0V24H24V22.5882H22.5882V9.88232H1.41176ZM10.5882 22.5882H9.17647V14.1176H4.94118V22.5882H3.52941V12.7059H10.5882V22.5882ZM20.4706 17.8244C18.3189 18.5161 15.5436 18.5089 13.4118 17.8245V11.8142C15.7813 11.1282 18.1016 11.1283 20.4706 11.8142V17.8244Z"
                    fill="rgb(var(--locumate-primary-color))" />
                  <path
                    d="M14.8235 16.7224C16.2203 17.0134 17.662 17.0134 19.0588 16.7225V15.5295H14.8235V16.7224ZM0 8.4707H1.41176V9.88247H0V8.4707ZM22.5882 8.4707H24V9.88247H22.5882V8.4707Z"
                    fill="rgb(var(--locumate-primary-color))" />
                </g>
                <defs>
                  <clipPath id="clip0_2459_4910">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{exp?.title}}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  <!-- Master of Pharmacy -->
                </p>
                <p class="enhance-item-dates">
                  {{ exp.dateStart?.split('-')[0] }} - {{ exp.dateEnd?.split('-')[0]}}
                </p>
              </div>
            </div>

          </div>
        </div>
        <div class="separator" v-if="userData.skills.length > 0"></div>
        <div class="preview-section" v-if="userData.skills.length > 0">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Skills
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openSkillsDialog">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path
                    d="M8.84006 2.39982L3.36673 8.19315C3.16006 8.41315 2.96006 8.84649 2.92006 9.14649L2.6734 11.3065C2.58673 12.0865 3.14673 12.6198 3.92006 12.4865L6.06673 12.1198C6.36673 12.0665 6.78673 11.8465 6.9934 11.6198L12.4667 5.82649C13.4134 4.82649 13.8401 3.68649 12.3667 2.29315C10.9001 0.913152 9.78673 1.39982 8.84006 2.39982Z"
                    stroke="#484848" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003" stroke="#484848"
                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2 14.6665H14" stroke="#484848" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>

            </div>
          </div>

          <div class="skill-list-pills">
            <el-tag v-for="(skill, index) in userData.skills" :key="index" class="inverted pill">{{ skill.name
              }}</el-tag>

          </div>
        </div>

        <div class="separator" v-if="userData.settings?.hrFlowData?.educations"></div>
        <div class="preview-section" v-if="userData.settings?.hrFlowData?.educations">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Education
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openEducationDialog">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path
                    d="M8.84006 2.39982L3.36673 8.19315C3.16006 8.41315 2.96006 8.84649 2.92006 9.14649L2.6734 11.3065C2.58673 12.0865 3.14673 12.6198 3.92006 12.4865L6.06673 12.1198C6.36673 12.0665 6.78673 11.8465 6.9934 11.6198L12.4667 5.82649C13.4134 4.82649 13.8401 3.68649 12.3667 2.29315C10.9001 0.913152 9.78673 1.39982 8.84006 2.39982Z"
                    stroke="#484848" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003" stroke="#484848"
                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2 14.6665H14" stroke="#484848" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>

            </div>
          </div>
          <div class="enhance-item border-box" v-for="(edu,index) in userData.settings?.hrFlowData?.educations"
            :key="index">
            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.8942 7.06186H8.10581L12 5.06091L15.8942 7.06186ZM15.8942 11.4626H22.3694V21.2156H15.8939L15.8942 11.4626ZM17.8482 14.8203H20.4156V13.4503H17.848L17.8482 14.8203ZM20.4156 17.4641H17.848V18.8341H20.4154L20.4156 17.4641ZM8.10628 21.2154H1.63059V11.4626H8.10604L8.10628 21.2154ZM6.15224 17.4641H3.58457V18.8341H6.15201L6.15224 17.4641ZM3.58481 14.8203H6.15224V13.4503H3.58457L3.58481 14.8203ZM15.8942 10.8063H22.3694V9.19936C22.3694 9.15851 22.3531 9.11935 22.3242 9.09046C22.2953 9.06158 22.2562 9.04533 22.2153 9.04528H15.8939L15.8942 10.8063ZM10.8292 18.9917V21.2156H13.1708V18.9917C13.1708 18.6812 13.0475 18.3834 12.8279 18.1638C12.6083 17.9442 12.3105 17.8208 12 17.8208C11.6895 17.8208 11.3917 17.9442 11.1721 18.1638C10.9525 18.3834 10.8292 18.6812 10.8292 18.9917ZM15.2377 7.71825H8.76229V10.8063H15.2377V7.71825ZM8.10604 9.04528H1.78467C1.74382 9.04533 1.70466 9.06158 1.67577 9.09046C1.64689 9.11935 1.63064 9.15851 1.63059 9.19936V10.8063H8.10604V9.04528ZM22.7465 21.8719H1.25353C1.12367 21.8719 0.999139 21.9235 0.907319 22.0153C0.8155 22.1071 0.763916 22.2316 0.763916 22.3615C0.763916 22.4913 0.8155 22.6159 0.907319 22.7077C0.999139 22.7995 1.12367 22.8511 1.25353 22.8511H22.7465C22.8763 22.8511 23.0009 22.7995 23.0927 22.7077C23.1845 22.6159 23.2361 22.4913 23.2361 22.3615C23.2361 22.2316 23.1845 22.1071 23.0927 22.0153C23.0009 21.9235 22.8763 21.8719 22.7465 21.8719ZM13.8271 21.2156V18.9917C13.8271 18.5071 13.6346 18.0424 13.2919 17.6997C12.9493 17.3571 12.4846 17.1646 12 17.1646C11.5154 17.1646 11.0507 17.3571 10.708 17.6997C10.3654 18.0424 10.1729 18.5071 10.1729 18.9917V21.2156H8.76229V11.4626H15.2377V21.2156H13.8271ZM13.2837 13.4503H10.7163V14.8203H13.2837V13.4503ZM12.3281 4.4917V2.88389C12.5224 2.83517 12.722 2.81032 12.9223 2.80988C13.2809 2.80924 13.6345 2.89434 13.9536 3.05808C14.1582 3.16004 14.3814 3.21937 14.6096 3.23247C14.8378 3.24556 15.0663 3.21215 15.2812 3.13425V1.82789C14.7363 1.96999 14.1581 1.90803 13.6556 1.65366C13.451 1.55178 13.2279 1.49251 12.9997 1.47944C12.7715 1.46638 12.543 1.49978 12.3281 1.57763V1.47656C12.3281 1.38954 12.2935 1.30608 12.232 1.24454C12.1705 1.18301 12.087 1.14844 12 1.14844C11.913 1.14844 11.8295 1.18301 11.768 1.24454C11.7064 1.30608 11.6719 1.38954 11.6719 1.47656V4.4917L12 4.32295L12.3281 4.4917Z"
                  fill="#1746BB" />
              </svg>


            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{ edu.school }}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  {{ edu.title }}
                </p>
                <p class="enhance-item-dates">
                  {{ edu.dateStart?.split('-')[0] }} - {{ edu.dateEnd?.split('-')[0]}}
                </p>
              </div>
            </div>

          </div>
        </div>

        <div class="separator" v-if="userData.settings?.hrFlowData?.certifications"></div>
        <div class="preview-section" v-if="userData.settings?.hrFlowData?.certifications">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Certifications
            </div>
            <div data-testid="directions-120" class="edit-icon" @click="openCertificateDialog">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path
                    d="M8.84006 2.39982L3.36673 8.19315C3.16006 8.41315 2.96006 8.84649 2.92006 9.14649L2.6734 11.3065C2.58673 12.0865 3.14673 12.6198 3.92006 12.4865L6.06673 12.1198C6.36673 12.0665 6.78673 11.8465 6.9934 11.6198L12.4667 5.82649C13.4134 4.82649 13.8401 3.68649 12.3667 2.29315C10.9001 0.913152 9.78673 1.39982 8.84006 2.39982Z"
                    stroke="#484848" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003" stroke="#484848"
                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M2 14.6665H14" stroke="#484848" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>

            </div>
          </div>
          <div class="enhance-item border-box" v-for="(cer,index) in userData.settings?.hrFlowData?.certifications"
            :key="index">
            <div class="enhance-item-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.8942 7.06186H8.10581L12 5.06091L15.8942 7.06186ZM15.8942 11.4626H22.3694V21.2156H15.8939L15.8942 11.4626ZM17.8482 14.8203H20.4156V13.4503H17.848L17.8482 14.8203ZM20.4156 17.4641H17.848V18.8341H20.4154L20.4156 17.4641ZM8.10628 21.2154H1.63059V11.4626H8.10604L8.10628 21.2154ZM6.15224 17.4641H3.58457V18.8341H6.15201L6.15224 17.4641ZM3.58481 14.8203H6.15224V13.4503H3.58457L3.58481 14.8203ZM15.8942 10.8063H22.3694V9.19936C22.3694 9.15851 22.3531 9.11935 22.3242 9.09046C22.2953 9.06158 22.2562 9.04533 22.2153 9.04528H15.8939L15.8942 10.8063ZM10.8292 18.9917V21.2156H13.1708V18.9917C13.1708 18.6812 13.0475 18.3834 12.8279 18.1638C12.6083 17.9442 12.3105 17.8208 12 17.8208C11.6895 17.8208 11.3917 17.9442 11.1721 18.1638C10.9525 18.3834 10.8292 18.6812 10.8292 18.9917ZM15.2377 7.71825H8.76229V10.8063H15.2377V7.71825ZM8.10604 9.04528H1.78467C1.74382 9.04533 1.70466 9.06158 1.67577 9.09046C1.64689 9.11935 1.63064 9.15851 1.63059 9.19936V10.8063H8.10604V9.04528ZM22.7465 21.8719H1.25353C1.12367 21.8719 0.999139 21.9235 0.907319 22.0153C0.8155 22.1071 0.763916 22.2316 0.763916 22.3615C0.763916 22.4913 0.8155 22.6159 0.907319 22.7077C0.999139 22.7995 1.12367 22.8511 1.25353 22.8511H22.7465C22.8763 22.8511 23.0009 22.7995 23.0927 22.7077C23.1845 22.6159 23.2361 22.4913 23.2361 22.3615C23.2361 22.2316 23.1845 22.1071 23.0927 22.0153C23.0009 21.9235 22.8763 21.8719 22.7465 21.8719ZM13.8271 21.2156V18.9917C13.8271 18.5071 13.6346 18.0424 13.2919 17.6997C12.9493 17.3571 12.4846 17.1646 12 17.1646C11.5154 17.1646 11.0507 17.3571 10.708 17.6997C10.3654 18.0424 10.1729 18.5071 10.1729 18.9917V21.2156H8.76229V11.4626H15.2377V21.2156H13.8271ZM13.2837 13.4503H10.7163V14.8203H13.2837V13.4503ZM12.3281 4.4917V2.88389C12.5224 2.83517 12.722 2.81032 12.9223 2.80988C13.2809 2.80924 13.6345 2.89434 13.9536 3.05808C14.1582 3.16004 14.3814 3.21937 14.6096 3.23247C14.8378 3.24556 15.0663 3.21215 15.2812 3.13425V1.82789C14.7363 1.96999 14.1581 1.90803 13.6556 1.65366C13.451 1.55178 13.2279 1.49251 12.9997 1.47944C12.7715 1.46638 12.543 1.49978 12.3281 1.57763V1.47656C12.3281 1.38954 12.2935 1.30608 12.232 1.24454C12.1705 1.18301 12.087 1.14844 12 1.14844C11.913 1.14844 11.8295 1.18301 11.768 1.24454C11.7064 1.30608 11.6719 1.38954 11.6719 1.47656V4.4917L12 4.32295L12.3281 4.4917Z"
                  fill="#1746BB" />
              </svg>

            </div>
            <div class="enhance-item-content">
              <p class="enhance-item-title">{{ cer.name }}</p>
              <div class="enhance-item-inner-row">
                <p class="enhance-item-info">
                  <!-- Master of Pharmacy -->
                </p>
                <p class="enhance-item-dates">
                  <!-- 2016 - 2018 -->
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="separator" v-if="userData.locumCvs.length > 0"></div>
        <div class="preview-section" v-if="userData.locumCvs.length > 0">
          <div class="preview-section__header">
            <div class="preview-section__title">
              Resume
            </div>
          </div>

          <div class="pdf-preview border-box">
            <div class="pdf-preview__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.0666 2.94682C20.5199 2.40015 19.5732 2.77349 19.5732 3.53349V8.18682C19.5732 10.1335 21.2266 11.7468 23.2399 11.7468C24.5066 11.7602 26.2666 11.7602 27.7732 11.7602C28.5332 11.7602 28.9332 10.8668 28.3999 10.3335C26.4799 8.40015 23.0399 4.92015 21.0666 2.94682Z"
                  fill="#00B7AF" />
                <path
                  d="M27.3333 13.5865H23.4799C20.3199 13.5865 17.7466 11.0132 17.7466 7.85317V3.99984C17.7466 3.2665 17.1466 2.6665 16.4133 2.6665H10.7599C6.65325 2.6665 3.33325 5.33317 3.33325 10.0932V21.9065C3.33325 26.6665 6.65325 29.3332 10.7599 29.3332H21.2399C25.3466 29.3332 28.6666 26.6665 28.6666 21.9065V14.9198C28.6666 14.1865 28.0666 13.5865 27.3333 13.5865ZM15.3333 23.6665H9.99992C9.45325 23.6665 8.99992 23.2132 8.99992 22.6665C8.99992 22.1198 9.45325 21.6665 9.99992 21.6665H15.3333C15.8799 21.6665 16.3333 22.1198 16.3333 22.6665C16.3333 23.2132 15.8799 23.6665 15.3333 23.6665ZM17.9999 18.3332H9.99992C9.45325 18.3332 8.99992 17.8798 8.99992 17.3332C8.99992 16.7865 9.45325 16.3332 9.99992 16.3332H17.9999C18.5466 16.3332 18.9999 16.7865 18.9999 17.3332C18.9999 17.8798 18.5466 18.3332 17.9999 18.3332Z"
                  fill="#00B7AF" />
              </svg>
            </div>
            <div class="pdf-preview-detail" v-for="(cvs,index) in userData.locumCvs" :key="index">
              <p class="pdf-preview-title">{{ cvs.fileName }}</p>
              <p class="pdf-preview-info">File size {{cvs.size}}MB | {{ cvs.createdAt }}</p>
            </div>
            <div data-testid="directions-120" class="edit-icon ml-auto p-2" @click="openResumeDialog">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;">
                <path d="M12.9834 10.0001C12.9834 11.6501 11.6501 12.9834 10.0001 12.9834C8.35006 12.9834 7.01672 11.6501 7.01672 10.0001C7.01672 8.35006 8.35006 7.01672 10.0001 7.01672C11.6501 7.01672 12.9834 8.35006 12.9834 10.0001Z" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99999 16.8916C12.9417 16.8916 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00831 17.5917 7.83331C15.6833 4.83331 12.9417 3.09998 9.99999 3.09998C7.05833 3.09998 4.31666 4.83331 2.40833 7.83331C1.65833 9.00831 1.65833 10.9833 2.40833 12.1583C4.31666 15.1583 7.05833 16.8916 9.99999 16.8916Z" stroke="#0B359A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </div>
          </div>
        </div>
      </div>
      <el-form>
        <el-form-item class="button_submit mb0">
          <el-button class="submit btn-primary" type="primary" data-testid="directions-122" @click="handleSubmit">
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>

  <!-- About me dialog -->
  <el-drawer title="About Me" v-model="dialogVisible" :append-to-body="true"
    :direction="'btt'" :destroy-on-close="true">

    <el-form :model="editAboutForm" ref="editForm">
      <el-form-item>
        <el-input v-model="editAboutForm.about_me" type="textarea" :maxlength="500" rows="4"></el-input>
      </el-form-item>
      <div class="char-counter">{{ characterCount }}/500</div>
    </el-form>
    <div slot="footer" class="dialog-footer with-gap">
      <el-button type="primary" @click="saveAboutMe">Save</el-button>
      <el-button class="secondary" @click="closeDialog">Cancel</el-button>
    </div>

  </el-drawer>

  <!-- experience dialog  -->
  <ExperiencesDrawer :experienceDialogVisible="experienceDialogVisible" @closeExperienceDrawer="closeExperienceDialog"/>

  <!-- Edit Skills dialog -->
  <el-drawer title="Skills" v-model="skillsDialogVisible" :append-to-body="true"
    :direction="'btt'" :destroy-on-close="true">
    <div class="edit-skills-drawer">
      <el-select class="skill-search-selector custom-select" popper-class="normal-select" v-model="selectedSkills" multiple filterable remote :loading="loading"
        :remote-method="remoteMethod" placeholder="Select Skills">
        <el-option v-for="item in skillsOptions" :key="item.value" :label="item.label" :value="item"></el-option>
      </el-select>
      <div class="edit-skills-container">
        <div class="tags-wrapper">
          <el-tag v-for="(skill, index) in editSkillsForm.skills" :key="index" closable @close="removeSkill(skill)" class="edit-skill-tag inverted pill">
            {{ skill.name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div slot="footer" class="d-flex gap-1 my-3">
      <el-button type="primary" class="mt-0" @click="saveSkills" v-if="showSaveSkillsBtn">Save</el-button>
      <el-button class="secondary mt-0" @click="closeSkillsDialog">Cancel</el-button>
    </div>

  </el-drawer>

    <!-- education dialog  -->
    <EducationsDrawer :educationDialogVisible="educationDialogVisible" @closeEducationDrawer="closeEducationDialog"/>
  <!-- certificate dialog  -->
  <CertificationsDrawer :certificationDialogVisible="certificationDialogVisible" @closeCertificationDrawer="closeCertificationDialog"/>
  <!-- resume dialog -->
  <!-- <el-dialog v-model="resumeDialogVisible" title="Resume" @close="closeCertificateDialog"> -->
  <el-drawer v-model="resumeDialogVisible" :append-to-body="true" title="Resume"
    :direction="'btt'" :destroy-on-close="true">
    <vue-pdf-embed v-if="userData.locumCvs && userData.locumCvs.length > 0"
      :source="userData.locumCvs[0].url"></vue-pdf-embed>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="closeCertificateDialog">Cancel</el-button>
        <el-button type="primary" @click="saveCertificates">Save</el-button> -->
    </div>
  </el-drawer>
</template>

<script setup>
import { inject, onMounted, ref, reactive, watch, computed, onBeforeMount  } from 'vue';
import { IonToolbar, IonButton, IonButtons, IonIcon } from '@ionic/vue';
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router';
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import ExperiencesDrawer from '../../Profile/Components/ExperiencesDrawer.vue';
import EducationsDrawer from '../../Profile/Components/EducationsDrawer.vue';
import CertificationsDrawer from '../../Profile/Components/CertificationsDrawer.vue';
// import {ElMessageBox as MessageBox} from "@/components/Vendor/Element";

import VuePdfEmbed from 'vue-pdf-embed';

import EditOutlineIcon from '@/components/Icons/EditOutlineIcon.vue';

const setPageClassGlobal = inject(['setPageClassGlobal']);
const $store = useStore();
const $router = useRouter();
const $route = useRoute();

const userData = ref($store.getters.GET_USER_DATA ? $store.getters.GET_USER_DATA : {});
console.log("🚀 ~ userData:", userData.value)
const dialogVisible = ref(false);
const skillsDialogVisible = ref(false);
const experienceDialogVisible = ref(false);
const educationDialogVisible = ref(false);
const certificationDialogVisible = ref(false);
const resumeDialogVisible = ref(false);
const routeName = $route.name;
const originalSkills = ref([]);

const state = reactive({
  isTruncated: true
});
// const pageText = {
//   pageTitle: 'Preview your profile',
//   formText: 'Start typing your home address and select it from the suggested list. We will use it to recommend opportunities near you.',
// };

// const displayedText = computed(() => {
//   const aboutMeText = userData.value.settings?.aboutMe;
//   if (state.isTruncated && aboutMeText != null) {
//     return aboutMeText.split(' ').slice(0, 50).join(' ') + '...';
//   } else {
//     return aboutMeText;
//   }
// });

const displayedText = computed(() => {
      const aboutMeText = userData.value?.settings?.aboutMe || userData.value?.locumAsJobSeekerSetting?.aboutMe || '';
      if (state.isTruncated && aboutMeText && aboutMeText.split(' ').length > 50) {
        return aboutMeText.split(' ').slice(0, 50).join(' ') + '...';
      } else {
        return aboutMeText;
      }
    });

const toggleView = () => {
  state.isTruncated = !state.isTruncated;
};

const openDialog = () => {
  editAboutForm.about_me = userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || '';
  dialogVisible.value = true;
};

const openExperienceDialog = () => {
  experienceDialogVisible.value = true;
};
const openEducationDialog = () => {
  educationDialogVisible.value = true;
};
const openCertificateDialog = () => {
  certificationDialogVisible.value = true;
};

const openResumeDialog = () => {
  resumeDialogVisible.value = true;
};

// Form model for editing About Me
const editAboutForm = reactive({
  about_me: userData.value.settings?.aboutMe || userData.value.locumAsJobSeekerSetting?.aboutMe || ''
});

const editSkillsForm = reactive({
  skills: userData.value.skills ? userData.value.skills : [],
});

const selectedSkills = ref([]);
const skillsOptions = ref([]);
const loading = ref(false);


const remoteMethod = async (query) => {
  try {
    const response = await $store.dispatch("GET_ALL_SKILLS", {
      'search': query
    });
    skillsOptions.value = response.data
      .map(skill => ({ label: skill.name, value: skill.id }));
  } catch (error) {
    console.error('Error fetching skills:', error);
  }
};


watch(selectedSkills, (newSelectedSkills, oldSelectedSkills) => {
  const addedSkills = newSelectedSkills.filter(skill => !oldSelectedSkills.some(oldSkill => oldSkill.value === skill.value));
  const removedSkills = oldSelectedSkills.filter(skill => !newSelectedSkills.some(newSkill => newSkill.value === skill.value));

  // Transform selected skills to desired format
  const transformedSkills = newSelectedSkills.map(skill => ({
    name: skill.label,
    id: skill.value
  }));

  // Add new selected skills to editSkillsForm.skills
  editSkillsForm.skills.push(...transformedSkills.filter(skill => addedSkills.some(addedSkill => addedSkill.value === skill.id)));

  // Remove deselected skills from editSkillsForm.skills
  removedSkills.forEach(removedSkill => {
    const index = editSkillsForm.skills.findIndex(skill => skill.id === removedSkill.value);
    if (index !== -1) {
      editSkillsForm.skills.splice(index, 1);
    }
  });
});

// Computed property to calculate the character count
const characterCount = computed(() => editAboutForm.about_me.length);

const closeDialog = () => {
  dialogVisible.value = false;
};
const closeExperienceDialog = () => {
  experienceDialogVisible.value = false;
};
const closeEducationDialog = () => {
  educationDialogVisible.value = false;
};

const closeCertificationDialog = () => {
  certificationDialogVisible.value = false;
};

// Method to save edited About Me
const saveAboutMe = async () => {
  // Save data using Vuex action or any other method
  try {
    await ElMessageBox.confirm(
      `Are you sure you want to update about me?`,
      "Update",
      {
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonClass: "el-button--primary",
        cancelButtonClass: "el-button--grey",
        showClose: false,
      }
    );

    await (async () => {
      try {
        const response = await $store.dispatch("UPDATE_JOB_SEEKER_ABOUT", { params: editAboutForm });
        console.log("🚀 ~ await ~ response:", response)
        $store.dispatch("SET_CURRENT_USER_DATA", {
          with:
            "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
        });
        if (response.success) {
          ElMessage({
            type: "success",
            message: response.message,
          });

        } else {
          ElMessage({
            type: "info",
            message: response.message,
          });
        }
      } catch (error) {
        ElMessage({
          type: "error",
          message: error.message,
        });
      }
    })();
  } catch (error) {
    console.log(error);
  }
  // Close dialog after saving

  closeDialog();
};

const goNext = () => {
  $router.push({
    name: 'job_seeker_index',
  });
};
// Method to open skills dialog
const openSkillsDialog = () => {
  originalSkills.value = JSON.parse(JSON.stringify(userData.value.skills));
  editSkillsForm.skills = JSON.parse(JSON.stringify(originalSkills.value));
  skillsDialogVisible.value = true;
};

// Method to close skills dialog
const closeSkillsDialog = () => {
  editSkillsForm.skills = JSON.parse(JSON.stringify(originalSkills.value));
  selectedSkills.value = [];
  skillsDialogVisible.value = false;
};

const showSaveSkillsBtn = computed(() => {
      return editSkillsForm.skills.length > 0;
    });

// Method to remove a skill from editSkillsForm
const removeSkill = (skill) => {
  const skillIndex = editSkillsForm.skills.findIndex(s => s.id === skill.id);
  if (skillIndex !== -1) {
    editSkillsForm.skills.splice(skillIndex, 1);
  }

  const selectedSkillIndex = selectedSkills.value.findIndex(s => s.value === skill.id);
  if (selectedSkillIndex !== -1) {
    selectedSkills.value.splice(selectedSkillIndex, 1);
  }
};

// Method to save edited skills
const saveSkills = async () => {

  try {
    await ElMessageBox.confirm(
      `Are you sure you want to update skills?`,
      "Update Skills",
      {
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonClass: "el-button--primary",
        cancelButtonClass: "el-button--grey",
        showClose: false,
      }
    );

    await (async () => {
      try {
        const response = await $store.dispatch("UPDATE_JOB_SEEKER_SKILLS", { params: editSkillsForm });
        console.log("🚀 ~ await ~ response:", response)
        $store.dispatch("SET_CURRENT_USER_DATA", {
          with:
            "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
        });
        if (response.status) {
          ElMessage({
            type: "success",
            message: response.message,
          });
          selectedSkills.value = [];
              skillsDialogVisible.value = false;
        } else {
          ElMessage({
            type: "info",
            message: response.message,
          });
        }
      } catch (error) {
        ElMessage({
          type: "error",
          message: error.message,
        });
      }
    })();
  } catch (error) {
    console.log(error);
  }
};
const handleSubmit = async () => {

  (async () => {
    try {

      const hello = await $store.dispatch("SAVE_JOB_PREVIEW_PUBLISH", []);
     
      console.log("🚀 ~ hello:", hello)
      goNext();
    } catch (error) {
      console.log("error submit!!");
    }
  })();
  // goNext();
  // alert('Form submitted successfully');
};

const isDisplayButtonVisible = computed(() => {
      const aboutMeText = userData.value?.settings?.aboutMe || '';
      return aboutMeText.split(' ').length > 50;
    });

const links = {
  changePhoto: () => {
    $router.push({
      name: "job_seeker_change_photo",
    });
  },
};

onBeforeMount(async () => {
    await $store.dispatch("SET_CURRENT_USER_DATA", {
      with: "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
    });
  });

onMounted(async () => {
  setPageClassGlobal('global_auth_page');
  
 
});

const goBack = () => {
  if (routeName == 'locum_jobseeker_preview') {
    $router.push({
      name: "locum_jobseeker_enhance",
    });
  } else {
    $router.push({
      name: 'jobseeker_auth_enhance',
    });
  }
   
};

</script>

<style scoped>
.char-counter {
  text-align: right;
  color: #888;
  font-size: 12px;
  margin-top: 5px;
}
</style>